import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { EMPTY_QUERY_PARAM } from "@l2r-front/l2r-query"
import { sortCatalogChildTypes } from "@l2r-front/l2r-utils"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQueries, useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideTypes(parent = EMPTY_QUERY_PARAM, config = {}) {
    const url = "roadside_inventory_types/"
    const { selectedNetwork } = useNetworksStateContext()
    const { country } = selectedNetwork

    const parameters = {
        country,
        parent: parent || EMPTY_QUERY_PARAM,
    }

    const queryKey = roadsideQueryKeys["roadsideType"](parameters)

    const { data, isLoading, isError, isFetching } = useRoadsideQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        data.sort((a, b) => a.code.localeCompare(b.code))
        data.forEach(d => sortCatalogChildTypes(d))
    }

    return { data, isLoading, isError, isFetching }
}

export function useRoadsideType(code, queryParameters = {}, config = {}) {
    const url = `roadside_inventory_types/${code}/`
    const queryKey = roadsideQueryKeys["roadsideType"]({ ...queryParameters, code })

    const { data, isLoading, isError } = useRoadsideQuery(
        url,
        queryKey,
        { ...queryParameters },
        {
            enabled: !!code,
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        sortCatalogChildTypes(data)
    }

    return { data, isLoading, isError }
}

export function useRoadsideTypeQueries(roadsides = [], config = {}) {
    const uniqueTypes = [...new Set(roadsides.map(roadside => roadside.roadside_inventory_type))]
    const queries = uniqueTypes.map(type => {
        const url = `roadside_inventory_types/${type}/`
        const queryKey = roadsideQueryKeys["roadsideType"](type)
        return ({
            url,
            queryKey,
            queryParameters: {},
            config: {
                ...config,
                autoRefetch: true,
            },
        })
    })

    return useRoadsideQueries(queries)
}